/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingWallet } from './BillingWallet';
import {
    BillingWalletFromJSON,
    BillingWalletFromJSONTyped,
    BillingWalletToJSON,
    BillingWalletToJSONTyped,
} from './BillingWallet';

/**
 * 
 * @export
 * @interface CreateBillingWalletResponse
 */
export interface CreateBillingWalletResponse {
    /**
     * 
     * @type {BillingWallet}
     * @memberof CreateBillingWalletResponse
     */
    data: BillingWallet;
}

/**
 * Check if a given object implements the CreateBillingWalletResponse interface.
 */
export function instanceOfCreateBillingWalletResponse(value: object): value is CreateBillingWalletResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateBillingWalletResponseFromJSON(json: any): CreateBillingWalletResponse {
    return CreateBillingWalletResponseFromJSONTyped(json, false);
}

export function CreateBillingWalletResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBillingWalletResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BillingWalletFromJSON(json['data']),
    };
}

  export function CreateBillingWalletResponseToJSON(json: any): CreateBillingWalletResponse {
      return CreateBillingWalletResponseToJSONTyped(json, false);
  }

  export function CreateBillingWalletResponseToJSONTyped(value?: CreateBillingWalletResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BillingWalletToJSON(value['data']),
    };
}

